// extracted by mini-css-extract-plugin
export default {"drawer":"NavDrawer_drawer__MzfIY","column":"NavDrawer_column__QTTXl"};